import React from "react";
import { Link } from "react-router-dom";
// Seperate page not yet created

function CandRegVerif() {
  const moveToNext = (currentInput, nextInputId) => {
    if (currentInput.value.length === 1 && nextInputId) {
      document.getElementById(nextInputId).focus();
    }
  };
  return (
    <div>
      <form class="form formOTP m-auto mt-5">
        {" "}
        <div class="title">OTP</div> <div class="title">Verification Code</div>{" "}
        <p class="message">
          We have sent a verification code to your mobile number
        </p>{" "}
        <div class="inputs">
          {" "}
          <input
            type="text"
            maxLength="1"
            className="otp-input"
            id="digit1" 
            onInput={() =>
              moveToNext(document.getElementById("digit1"), "digit2")
            }
            autoComplete="off"
          />
          <input
            type="text"
            maxLength="1"
            className="otp-input"
            id="digit2"
            onInput={() =>
              moveToNext(document.getElementById("digit2"), "digit3")
            }
            autoComplete="off"
          />
          <input
            type="text"
            maxLength="1"
            className="otp-input"
            id="digit3"
            onInput={() =>
              moveToNext(document.getElementById("digit3"), "digit4")
            }
            autoComplete="off"
          />
          <input
            type="text"
            maxLength="1"
            className="otp-input"
            id="digit4"
            onInput={() => moveToNext(document.getElementById("digit4"), null)}
            autoComplete="off"
          />
        </div>{" "}
        <Link to={"/home2"}>
          <button class="action">Verify me</button>{" "}
        </Link>
      </form>
    </div>
  );
}

export default CandRegVerif;
